/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function Maximize({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" d="M14.428 1.58A.6.6 0 0 1 14.6 2v4a.6.6 0 1 1-1.2 0V3.449L9.924 6.924a.6.6 0 0 1-.848-.848L12.552 2.6H10a.6.6 0 0 1 0-1.2h4c.168 0 .32.069.428.18M2 14.6h4a.6.6 0 1 0 0-1.2H3.449l3.475-3.476a.6.6 0 0 0-.848-.848L2.6 12.552V10a.6.6 0 1 0-1.2 0v4a.6.6 0 0 0 .6.6" /></svg>;
}
;